
import PlayCricle from "../../../assets/duotone/PlayCricle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function PlayCricleIcon({ className, dataTestid = "PlayCricleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <PlayCricle data-testid={dataTestid} className={classes} {...rest} />
  );
}
